// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "c203838323193d81","191": "6a08590ede785837","396": "72881d38c5ca956e","460": "8a49372256e21745","498": "fac8f676629ada2d","917": "980abd1c201b9d69","985": "cab228a4d904e5dc",}[chunkId] + ".chunk.js"
}